'use client';

import { cn } from '@/app/utils';

interface LandingCtaProps {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export function LandingCta({ children, className, onClick }: LandingCtaProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'relative inline-flex items-center justify-center rounded-[10px] bg-[#305AE0] px-12 py-4 font-medium text-base text-white transition hover:bg-[#305AE0]/90 sm:px-8 sm:py-3 sm:text-sm',
        'shadow-[inset_0_-3px_0_0_#1944d0]',
        className,
      )}
    >
      {children}
    </button>
  );
}
